import { render, staticRenderFns } from "./DialogUsersAndCategoryAddUserGroup.vue?vue&type=template&id=07ca2675"
import script from "./DialogUsersAndCategoryAddUserGroup.vue?vue&type=script&lang=js"
export * from "./DialogUsersAndCategoryAddUserGroup.vue?vue&type=script&lang=js"
import style0 from "./DialogUsersAndCategoryAddUserGroup.vue?vue&type=style&index=0&id=07ca2675&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports